import { createFileRoute } from "@tanstack/react-router";
import { Terraform } from "../pages/blueprint/Terraform";

export const Route = createFileRoute("/terraform")({
  component: RouteComponent,
});

function RouteComponent() {
  return <Terraform />;
}
